import { HStack, Text } from '@chakra-ui/react';
import { Minus, TrendingDown, TrendingUp } from 'lucide-react';
import { StatusTone } from './StatusBadge';

interface DeltaBadgeProps {
  value: number | null | undefined;
  suffix?: string;
  positiveTone?: StatusTone;
  negativeTone?: StatusTone;
}

const toneColor: Record<StatusTone, string> = {
  success: 'status.success.fg',
  warning: 'status.warning.fg',
  danger: 'status.danger.fg',
  info: 'status.info.fg',
  neutral: 'status.neutral.fg',
};

export function DeltaBadge({
  value,
  suffix = '',
  positiveTone = 'success',
  negativeTone = 'danger',
}: DeltaBadgeProps) {
  if (value == null) {
    return (
      <Text fontSize="xs" color="ui.text.tertiary">
        -
      </Text>
    );
  }

  const Icon = value > 0 ? TrendingUp : value < 0 ? TrendingDown : Minus;
  const tone = value > 0 ? positiveTone : value < 0 ? negativeTone : 'neutral';
  const display = value > 0 ? `+${value}${suffix}` : `${value}${suffix}`;

  return (
    <HStack
      display="inline-flex"
      verticalAlign="middle"
      whiteSpace="nowrap"
      gap="1"
      color={toneColor[tone]}
    >
      <Icon size={12} />
      <Text fontSize="xs" fontWeight="700">
        {display}
      </Text>
    </HStack>
  );
}
